import React from "react";
import {
  TextField,
  Box,
  Typography,
  FormControl,
  Paper,
  FormLabel,
  Button,
  Tooltip,
  IconButton,
  Breadcrumbs,
  MenuItem,
  Alert,
  Stack,
  Avatar,
  Checkbox,
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  InputLabel,
  Select,
  useTheme,
  FormControlLabel,
} from "@mui/material";
import { Field } from "formik";
import useMediaQuery from "@mui/material/useMediaQuery";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import LogoutOutlinedIcon from "@mui/icons-material/LogoutOutlined";
import { Formik } from "formik";
import ResetTvIcon from "@mui/icons-material/ResetTv";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { tokens } from "../../../Theme";
import {
  fetchApidata,
  getFetchData,
  measureget,
  measurepost,
  postApidata,
  postData,
  requestMail,
} from "../../../store/reducers/Formapireducer";
import ListAltOutlinedIcon from "@mui/icons-material/ListAltOutlined";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-hot-toast";
import { useEffect, useState, useRef } from "react";
import Popup from "../popup";
import Listviewpopup from "../Lookup";
import Swal from "sweetalert2";
import { LoadingButton } from "@mui/lab";
import { useProSidebar } from "react-pro-sidebar";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import { FinanceSchema } from "../../Security/validation";
import { fileUpload } from "../../../store/reducers/Imguploadreducer";
import store from "../../../index";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { financeentrySchema } from "../../Security/validation";
import { CheckinAutocomplete, MultiFormikOptimizedAutocomplete, Employeeautocomplete, Productautocomplete } from "../../../ui-components/global/Autocomplete";
import { formGap } from "../../../ui-components/global/utils";
import { leaveAppoval, mailNotify } from "../../../store/reducers/Listviewapireducer";
import FileListPopup from "../../../ui-components/FIleViewDialog";
import FileUploadIconButton from "../../../ui-components/FileUploadButton";
import { attachmentPost } from "../../../store/reducers/LoginReducer";
import GradingIcon from '@mui/icons-material/Grading';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CryptoJS from 'crypto-js';
// import ErrorMsgData from "../../Security/validationMsg.json"
import * as Yup from "yup";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import {
  dataGridHeaderFooterHeight,
  dataGridRowHeight,
} from "../../../ui-components/global/utils";
import { fetchExplorelitview } from "../../../store/reducers/Explorelitviewapireducer";

// const validationSchema = Yup.object().shape({
//   overhead: Yup.object().required(ErrorMsgData.Expense.overhead).nullable(),
//   date: Yup.string().required(ErrorMsgData.Expense.date),
//   amount: Yup.string().required(ErrorMsgData.Expense.amount),
//   comments: Yup.string().required(ErrorMsgData.Expense.comments),
//   referenceifany: Yup.string().required(ErrorMsgData.Expense.referenceifany),
// });
const KEY = CryptoJS.enc.Utf8.parse('1234567890123456'); // 16-byte key
const IV = CryptoJS.enc.Utf8.parse('1234567890123456');  // 16-byte IV


export function encryptDataUrlSafe(plainText) {
  const encrypted = CryptoJS.AES.encrypt(plainText, KEY, {
    iv: IV,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(); // Standard base64

  // Convert to URL-safe base64
  return encrypted.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}


const Editfinance = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const accessID = params.accessID;
  const recID = params.id;
  const EMPID = sessionStorage.getItem("EmpId");
  const mode = params.Mode;
  const [open, setOpen] = useState(false);
  var parentID = params.parentID;
  console.log(parentID, "parentID");
  const filtertype = params.filtertype;
  const location = useLocation();
  const navigate = useNavigate();
  var secondaryCurrentPage = parseInt(
    sessionStorage.getItem("secondaryCurrentPage")
  );

  const SubscriptionCode = sessionStorage.getItem("SubscriptionCode");
  const is003Subscription = SubscriptionCode.endsWith("003");
  console.log(SubscriptionCode, is003Subscription, "SubscriptionCode");


  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [page, setPage] = React.useState(secondaryCurrentPage);
  const data = useSelector((state) => state.formApi.Data);
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);
  const isLoading = useSelector((state) => state.formApi.postLoading);

  const [rowCount, setRowCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [imgloading, setimgLoading] = useState(false);
  const [files, setFiles] = useState([]);
  const [error, setError] = useState('');
  const rowSx = { height: 36, '& td, & th': { py: 0.5 } };
  const getLoading = useSelector((state) => state.formApi.getLoading);
  const Finyear = sessionStorage.getItem("YearRecorid");
  const CompanyID = sessionStorage.getItem("companyId");
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const [showImage, setShowImage] = useState(params.Mode == "IM" ? true : false)
  // const validationSchema = Yup.object().shape({
  //   overhead: Yup.object()
  //     .nullable()
  //     .required("Overhead is required"),
  // });
  const [funMode, setFunMode] = useState("A");
  const [laomode, setLaoMode] = useState("A");
  const explorelistViewData = useSelector(
    (state) => state.exploreApi.explorerowData
  );
  const explorelistViewcolumn = useSelector(
    (state) => state.exploreApi.explorecolumnData
  );
  const exploreLoading = useSelector((state) => state.exploreApi.loading);
  const [errorMsgData, setErrorMsgData] = useState(null);
  const [validationSchema, setValidationSchema] = useState(null);
  const [validationSchema1, setValidationSchema1] = useState(null);
  const [attempData, setattempData] = useState(null);
  const [selectedPro, setSelectedPro] = useState([]);
  const [empData, setempData] = useState([]);
  const [show, setScreen] = React.useState("0");
  const [child, setchild] = useState("");
  const [OHId, setOHId] = useState("");
  const [Fetype, setFEtype] = useState("");
  console.log(OHId, "OHId");
  const measuregetdata = useSelector((state) => state.formApi.MeasureGetData);
  console.log(child, "childYorN");
  console.log(measuregetdata, "measuregetdata");
  const [pageSize, setPageSize] = React.useState(10);
  var userimg = store.getState().globalurl.imageUrl;
  if (mode == "A") {
    userimg = userimg + "Defaultimg.jpg";
  } else {
    if (
      data.ImageName == undefined ||
      data.ImageName == null ||
      data.ImageName == ""
    ) {
      userimg = userimg + "Defaultimg.jpg";
    } else {
      userimg = userimg + data.ImageName;
    }
  }

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/validationcms.json")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch validationcms.json");
        return res.json();
      })
      .then((data) => {
        setErrorMsgData(data);
        const schema = Yup.object().shape({
          overhead: Yup.object().required(data.Expense.overhead).nullable(),
          ProName: Yup.object().required(data.Expense.Project).nullable(),
          date: Yup.string().required(data.Expense.date),
          // amount: Yup.string().required(data.Expense.amount),
          comments: Yup.string().trim().required(data.Expense.comments),
          // managerComments: Yup.string().required(data.Expense.managerComments),
          managerComments:
            mode === "M" ||
              (mode === "E" && (data.Status === "RJ" || data.Status === "QR"))
              ? Yup.string().required(
                data?.Expense?.managerComments || "Manager Comments is required"
              )
              : Yup.string().notRequired(),

        Status: mode === "M" ? Yup.string().required(data.Expense.Status) : Yup.string().notRequired(),

        });

        setValidationSchema(schema);
        const schema1 = Yup.object().shape({
          // detailoverhead: Yup.object().required(data.Expense.overhead).nullable(),
          // detailamount: Yup.string().required(data.Expense.amount),
          uom: Yup.string().required(data.Expense.Uom).nullable(),

        });

        setValidationSchema1(schema1);
      })
      .catch((err) => console.error("Error loading validationcms.json:", err));
  }, [mode, data.Status]);
  useEffect(() => {
    dispatch(getFetchData({ accessID, get: "get", recID })).then((res) => {
      console.log(res, "response");
      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: EMPID,
            appId: data.RecordID
          }
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError('Failed to fetch attachments.');
          console.error(err);
        })
        .finally(() => setLoading(false));
    })
  }, [location.key]);
  const [productdata, setProductdata] = useState({
    recordID: "",
    detailamount: "",
    overheaddetail: "",
    description: ""

  });

  const [ImageName, setImgName] = useState("");
  const selectCellRowData = ({ rowData, mode, field, setFieldValue }) => {
    setFunMode(mode);
    setLaoMode(mode);

    if (mode == "A") {
      setProductdata({
        recordID: "",
        detailamount: "",
        overheaddetail: "",
        description: ""
      })
    } else {
      if (field == "action") {
        setProductdata({
          recordID: rowData.RecordID,
          detailamount: rowData.Amount,
          description: rowData.Name,
          overheaddetail: rowData.OverheadRecordID
            ? {
              RecordID: rowData.OverheadRecordID,
              Code: rowData.Code || "",
              Name: rowData.Name || "",
            }
            : null,
        });

        // setFieldValue("overheaddetail", {
        //   overheaddetail: rowData.OverheadRecordID,
        // });
        setFieldValue("overheaddetail", {
          RecordID: rowData.OverheadRecordID,
          Code: rowData.Code,
          Name: rowData.Name,
        });
      }
    }

  };
  console.log(selectCellRowData, "selectCellRowData");

  const screenChange = (event) => {
    setScreen(event.target.value);

    if (event.target.value == "0") {
      console.log(accessID, "accessID");
      dispatch(getFetchData({ accessID, get: "get", recID }));
    }

    if (event.target.value == "1") {


      dispatch(
        fetchExplorelitview(
          "TR086",
          "Expense Detail",
          `CompanyID='${CompanyID}' AND Type='D' AND FEHdrID='${recID}'`,
          // `CompanyID='${CompanyID}'`,
          ""
        )
      );

      selectCellRowData({ rowData: {}, mode: "A", field: "" });
    }
    if (event.target.value == "2") {
      dispatch(
        measureget({
          FinanceentryID: recID
          // ,OverheadsRecordID: OHId
        })
      );
    }


  };
  const currentDate = new Date().toISOString().split("T")[0];

  const initialValue = {
    applieddate: mode == "A" ? currentDate : data.AppliedDate,
    managerComments: mode == "M" ? data.ManagerComments : "",
    Status: mode === "M" ? "" : data.Status,
    date: data.FEDate,
    referenceifany: data.Referenceifany,
    amount: data.Amount || "0.00",
    comments: data.Comments,
    approvedby: data.Approvedby,
    ProName: data.ProjectID && data.ProjectID !== "0"
      ? { RecordID: data.ProjectID, Code: data.ProjectCode, Name: data.ProjectName }
      : null,
    Employee: data.EmpID && data.EmpID !== "0"
      ? { RecordID: data.EmpID, Code: data.EmpCode, Name: data.EmpName }
      : null,

    Product: data.ProductID && data.ProductID !== "0"
      ? { RecordID: data.ProductID, Code: data.ProductCode, Name: data.ProductName }
      : null,
    Material: data.MaterialID && data.MaterialID !== "0"
      ? { RecordID: data.MaterialID, Code: data.MaterialCode, Name: data.MaterialName }
      : null,
    Service: data.ServiceID && data.ServiceID !== "0"
      ? { RecordID: data.ServiceID, Code: data.ServiceCode, Name: data.ServiceName }
      : null,
    overhead: data.OverheadsRecordID
      ? { RecordID: data.OverheadsRecordID, Name: data.Name }
      : null,
  };
  const projecID = selectedPro.map(ProName => ProName.RecordID).join(',');


  const isNonMobile = useMediaQuery("(min-width:600px)");
  const fnSave = async (values, resetForm, del) => {
    // const employeeID = values?.Employee?.map(Employee => Employee.RecordID).join(',');
    // const ProductID = values?.Product?.map(Product => Product.RecordID).join(',');
    // const MaterialID = values?.Material?.map(Material => Material.RecordID).join(',');
    // const ServiceID = values?.Service?.map(Service => Service.RecordID).join(',');

    // console.log(ProductID, "Recordss");
    setLoading(true);

    const idata = {
      RecordID: recID,
      OverheadsRecordID: values?.overhead?.RecordID || 0,
      Name: values?.overhead?.Name || "",
      FEDate: values.date,
      Referenceifany: values.referenceifany,
      Amount: values.amount,
      Comments: values.comments,
      Approvedby: EMPID,
      // Approvedby: mode == "M" ? params.parentID : EMPID,
      FinanceCategoryType: "E",
      Attachment: ImageName ? ImageName : data.Attachment,
      AppliedDate: values.applieddate,
      // ProjectID: projecID || 0,
      // ProjectName: values.ProName?.Name || "",
      Reason: "",
      ManagerComments: values.managerComments,
      Status: mode == "A" ? "AL" : mode == "E" && values.Status == "RC" ? "AL" : values.Status,
      Finyear,
      ProjectID: values?.ProName?.RecordID || 0,
      EmployeeID: mode == "M" ? params.parentID : EMPID,
      ProductID: values?.Product?.RecordID || 0,
      MaterialID: values?.Material?.RecordID || 0,
      ServiceID: values?.Service?.RecordID || 0,
      EmpID: values?.Employee?.RecordID || 0,
      CompanyID,
      Source: "Self",
    };

    let action =
      mode === "A" && !del
        ? "insert"
        : mode === "E" && del
          ? "harddelete"
          : "update";
    const response = await dispatch(postData({ accessID, action, idata }));

    if (response.payload.Status == "Y") {
      setLoading(false);
      if (mode == "A") {
        dispatch(
          requestMail({
            EmployeeID: EMPID,
            Type: "EE",
            RecordID: response.payload.FinanceEntryRecid,
            encryptData: encryptDataUrlSafe(response.payload.FinanceEntryRecid)
          })
        );
        dispatch(
          leaveAppoval({
            data: {
              RecordID: response.payload.FinanceEntryRecid,
              ManagerID: "",
              EmployeeID: EMPID,
              Type: "EE",
              Status: "AL",
              Reason: "",
            },
          })
        );
      }
      if (mode == "M") {
        dispatch(
          leaveAppoval({
            data: {
              RecordID: recID,
              ManagerID: EMPID,
              EmployeeID: params.parentID,
              Type: "EE",
              Status: values.Status == "AP" ? "Y" : values.Status == "QR" ? values.Status : "N",
              Reason: "",
              Source: "M"
            },
          })
        );
        dispatch(mailNotify({
          RecordID: recID,
          ManagerID: EMPID,
          EmployeeID: params.parentID,
          Type: "EE",
          Status: values.Status == "AP" ? "Y" : values.Status == "QR" ? values.Status : "N",
          Reason: "",
          Source: "M"

        }));
      }

      toast.success(response.payload.Msg);
      // setIni(true)
      dispatch(
        measureget({
          FinanceentryID: response.payload.FinanceEntryRecid
        })
      );
      dispatch(
        fetchExplorelitview(
          "TR086",
          "Expense Detail",
          `CompanyID='${CompanyID}' AND Type='D' AND FEHdrID='${response.payload.FinanceEntryRecid}'`,
          ""
        )
      );
      // setchild(data.ChildYorN)
      // setScreen(data.ChildYorN || child === "Y" ? 1 : 2);
      const childFlag = values?.overhead?.ChildYorN
      setScreen(childFlag === "Y" ? 1 : 2);
      console.log(childFlag, "childFlag");

      navigate(`/Apps/Secondarylistview/TR086/Finance%20Entry/${parentID}/${filtertype}`);
      if (mode == "M") {
        navigate(-1);
      } else {
        // navigate("/Apps/Secondarylistview/TR086/Expense/E");
        navigate(`/Apps/Secondarylistview/TR086/Finance%20Entry/E/EditFinance%20Entry/${response.payload.FinanceEntryRecid}/E`);
      }
    } else {
      toast.error(response.payload.Msg);
      setLoading(false);
    }
  };

  const DetailinitialValues = {
    code: data.FEDate,
    description: data.Name,
    overheaddetail: productdata.overheaddetail ? productdata.overheaddetail : null,
    detailamount: productdata.detailamount ? productdata.detailamount : "0.00",
    // checkbox: productdata.disable == "Y" ? true : false,
    // sortorder: productdata.sortorder || ""
  };

  const AddexpFnsave = async (values, resetForm, del) => {
    setLoading(true);
    let action =
      funMode === "A" && !del
        ? "insert"
        : funMode === "E" && del
          ? "harddelete"
          : "update";
    const idata = {
      RecordID: productdata.recordID,
      FEDate: data.FEDate,
      Referenceifany: data.Referenceifany,
      Comments: data.Comments,
      Approvedby: EMPID,
      FinanceCategoryType: "E",
      AppliedDate: data.AppliedDate,
      Reason: "",
      ManagerComments: data.ManagerComments,
      Status: data.Status,
      ProjectID: data.ProjectID,
      ProductID: data.ProductID,
      MaterialID: data.MaterialID,
      ServiceID: data.ServiceID,
      EmpID: data.EmpID,
      OverheadsRecordID: values?.overheaddetail?.RecordID || 0,
      Amount: values.detailamount,
      // Disable: values.checkbox == true ? "Y" : "N",
      // Sortorder: values.sortorder || 0,
      CompanyID,
    };
    console.log(idata, "idataexpadd");


    const response = await dispatch(postData({ accessID: "TR086", action, idata }));

    if (response.payload.Status == "Y") {
      setLoading(false);
      toast.success(response.payload.Msg);
      // setIni(true)
      dispatch(
        fetchExplorelitview(
          "TR086",
          "Expense Detail",
          `CompanyID='${CompanyID}' AND Type='D' AND FEHdrID='${recID}'`,
          ""
        )
      );
      selectCellRowData({ rowData: {}, mode: "A", field: "" });
      resetForm();
    } else {
      toast.error(response.payload.Msg);
      setLoading(false);
    }
  };

  const initialValue2 = {
    code: data.FEDate,
    description: data.Name,
    measurecomments: measuregetdata.FE_COMMENTS,
    measureamount: measuregetdata.FE_VALUE,
    comments: measuregetdata.Comments,
    rate: measuregetdata.FE_RATE,
    Qty: measuregetdata.FE_QTY,
    uom: measuregetdata.FE_UOM,


  };

  // const MeasureFnsave = async (values, resetForm, del) => {
  //   setLoading(true);
  //   let action =
  //     funMode === "A" && !del
  //       ? "insert"
  //       : funMode === "E" && del
  //         ? "harddelete"
  //         : "update";
  //   const idata = {
  //     // RecordID: productdata.recordID,
  //     // Comments: data.measurecomments,
  //     // Amount: values.measureamount,
  //     // Rate: values.rate,
  //     // CompanyID,
  //     FinanceID: recID,
  //     SpotActivityID: 0,
  //     Uom: values.uom,
  //     Quantity: values.Qty,
  //     Rate: values.rate,
  //     FeValues: values.measureamount,
  //     Comments: values.measurecomments,
  //     Source: "W"
  //   };
  //   console.log(idata, "idataexpadd");
  //   const response = await dispatch(measurepost({idata }));

  //   if (response.payload.Status == "Y") {
  //     setLoading(false);
  //     toast.success(response.payload.Msg);
  //     // setIni(true)
  //     setScreen(1);
  //   } else {
  //     toast.error(response.payload.Msg);
  //     setLoading(false);

  //   }
  // };
  const MeasureFnsave = async (values, resetForm, del) => {
    setLoading(true);

    let action =
      funMode === "A" && !del
        ? "insert"
        : funMode === "E" && del
          ? "harddelete"
          : "update";

    const idata = {
      FinanceID: measuregetdata.FE_RECID,
      SpotActivityID: 0,
      Uom: values.uom,
      Quantity: values.Qty,
      Rate: values.rate,
      FeValues: values.measureamount,
      Comments: values.measurecomments,
      Source: "W",
      // OverheadsRecordID: OHId || 0,
      FEType: measuregetdata.FE_TYPE,
      HeaderID: measuregetdata.FE_FERECID

    };

    console.log("idataexpadd", idata);

    const response = await dispatch(measurepost(idata));

    if (response.payload?.Status === "Y") {
      toast.success(response.payload.Msg);

      setScreen(data?.ChildYorN === "Y" ? 1 : 0);

      dispatch(getFetchData({ accessID, get: "get", recID }));
      dispatch(
        fetchExplorelitview(
          "TR086",
          "Expense Detail",
          `CompanyID='${CompanyID}' AND Type='D' AND FEHdrID='${recID}'`,
          ""
        )
      );

    } else {
      toast.error(response.payload?.Msg || "Something went wrong");
    }

    setLoading(false);
  };

  const [isPopupData, setisPopupdata] = React.useState(false);
  const [selectOHLookupData, setselectOHLookupData] = React.useState({
    OHlookupRecordid: "",
    OHlookupCode: "",
    OHlookupDesc: "",
  });
  if (isPopupData == false) {
    selectOHLookupData.OHlookupRecordid = data.OverheadRecordID;
    selectOHLookupData.OHlookupCode = data.Code;
    selectOHLookupData.OHlookupDesc = data.Name;
  }
  const [selectEMPLOYEELookupData, setselectEMPLOYEELookupData] =
    React.useState({
      EMPLOYEElookupRecordid: "",
      EMPLOYEElookupCode: "",
      EMPLOYEElookupDesc: "",
    });
  if (isPopupData == false) {
    selectEMPLOYEELookupData.EMPLOYEElookupRecordid = data.Approvedby;
    selectEMPLOYEELookupData.EMPLOYEElookupCode = data.ApprovedCode;
    selectEMPLOYEELookupData.EMPLOYEElookupDesc = data.ApprovedName;
  }
  const [openOHPopup, setOpenOHPopup] = useState(false);
  const [openEMPLOYEEPopup, setOpenEMPLOYEEPopup] = useState(false);
  function handleShow(type) {
    if (type == "OH") {
      setOpenOHPopup(true);
    }
    if (type == "EMP" || type == "PRD" || type == "MAT" || type == "FIA") {
      setOpenEMPLOYEEPopup(true);
    }
  }

  //************************** Lookup value assign type based Function *****************/
  const childToParent = (childdata, type) => {
    console.log("type---" + type);
    console.log("Data---" + JSON.stringify(childdata));

    if (type == "OverHead") {
      setisPopupdata(true);
      setselectOHLookupData({
        OHlookupRecordid: childdata.RecordID,
        OHlookupCode: childdata.Code,
        OHlookupDesc: childdata.Name,
      });
      setOpenOHPopup(false);
    }
    if (
      type == "Employee" ||
      type == "Products" ||
      type == "Material" ||
      type == "Fixed Assets"
    ) {
      setisPopupdata(true);
      setselectEMPLOYEELookupData({
        EMPLOYEElookupRecordid: childdata.RecordID,
        EMPLOYEElookupCode: childdata.Code,
        EMPLOYEElookupDesc: childdata.Name,
      });
      setOpenEMPLOYEEPopup(false);
    }
  };
  const ref = useRef(null);
  // *************** GET FILES FROM INPUT *************** //

  const getFileChange = async (event) => {
    setImgName(event.target.files[0]);

    console.log(event.target.files[0]);

    const formData = new FormData();
    formData.append("file", event.target.files[0]);
    formData.append("type", "attachments");

    const fileData = await dispatch(fileUpload({ formData }));

    setImgName(fileData.payload.name);
    console.log(">>>", fileData.payload);
    console.log(
      "🚀 ~ file: Editdeliverychalan.jsx:1143 ~ getFileChange ~ fileData:",
      fileData
    );
    if (fileData.payload.Status == "Y") {
      // console.log("I am here");
      toast.success(fileData.payload.Msg);
    }
  };
  const fnLogOut = (props) => {
    //   if(Object.keys(ref.current.touched).length === 0){
    //     if(props === 'Logout'){
    //       navigate("/")}
    //       if(props === 'Close'){
    //         navigate("/Apps/TR022/Bank Master")
    //       }

    //       return
    //  }
    Swal.fire({
      title: errorMsgData.Warningmsg[props],
      // text:data.payload.Msg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: props,
    }).then((result) => {
      if (result.isConfirmed) {
        if (props === "Logout") {
          navigate("/");
        }
        if (props === "Close") {
          navigate(-1);
        }
      } else {
        return;
      }
    });
  };
  async function fileUpload(file, EMPID, action, id, purpose) {
    setimgLoading(true);
    console.log("🚀 ~ fileUpload ~ file:", file)
    const formData = new FormData();
    formData.append('file', file);
    formData.append('empId', EMPID);
    formData.append('appId', data.RecordID);
    formData.append('type', "EE");
    formData.append('source', "Self");
    formData.append("action", action);
    formData.append("id", id);
    formData.append("purpose", purpose ? purpose : "");
    console.log("🚀 ~ fileUpload ~ formData:", formData)
    const respose = await dispatch(attachmentPost({ data: formData }))

    if (respose.payload.success) {
      toast.success(respose.payload.message)
      var url = store.getState().globalurl.empGetAttachmentUrl;
      axios
        .get(url, {
          params: {
            empId: EMPID,
            appId: data.RecordID,

          }
        })
        .then((response) => {
          setFiles(response.data);
        })
        .catch((err) => {
          setError('Failed to fetch attachments.');
          console.error(err);
        })
        .finally(() => setimgLoading(false));
    } else {
      toast.success(respose.payload.message)
    }

    console.log("🚀 ~ fileUpload ~ respose:", respose)
  }
  let VISIBLE_FIELDS = [];

  if (show == "1") {
    VISIBLE_FIELDS = [
      "slno",
      "Overhead",
      "Value",
      "action",
    ];
  }

  const columns = React.useMemo(() => {
    let visibleColumns = explorelistViewcolumn.filter((column) =>
      VISIBLE_FIELDS.includes(column.field)
    );

    if (VISIBLE_FIELDS.includes("slno")) {
      const slnoColumn = {
        field: "slno",
        headerName: "SL#",
        width: 50,
        sortable: false,
        filterable: false,
        valueGetter: (params) =>
          page * pageSize +
          params.api.getRowIndexRelativeToVisibleRows(params.id) +
          1,
      };

      visibleColumns = [slnoColumn, ...visibleColumns];
      console.log("🚀 ~ Editoverhead ~ visibleColumns:", visibleColumns)
    }

    return visibleColumns;
  }, [explorelistViewcolumn, show, page, pageSize]);
  console.log("🚀 ~ Editoverhead ~ columns:", columns)
  function Employee() {
    return (
      <GridToolbarContainer
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row" }}>
          {/* <Typography>
              {show == "2" ? "List of Functions" : "List of Designation"}||{show=="6" && "List of Documents"}
              
            </Typography> */}
          <Typography>
            {show == "1"
              ? "List of Additional Expense Detail"
              : ""}
          </Typography>
          <Typography variant="h5">{`(${rowCount})`}</Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <GridToolbarQuickFilter />
          {/* <Tooltip title="ADD">
            <IconButton type="reset">
              <AddOutlinedIcon />
            </IconButton>
          </Tooltip> */}
        </Box>
      </GridToolbarContainer>
    );
  }
  return (
    <React.Fragment>
      {getLoading ? <LinearProgress /> : false}
      {imgloading ? <LinearProgress /> : false}
      <Paper elevation={3} sx={{ margin: "0px 10px", background: "#F2F0F0", height: "60px" }}>
        <Box display="flex" justifyContent="space-between" >
          <Box display="flex" borderRadius="3px" alignItems="center">
            <Breadcrumbs
              maxItems={3}
              aria-label="breadcrumb"
              separator={<NavigateNextIcon sx={{ color: "#0000D1" }} />}
            >
              <Typography
                variant="h5"
                color="#0000D1"
                sx={{ cursor: "default", paddingLeft: "5px" }}
                onClick={() => {
                  setScreen(0);
                }}
              >
                {is003Subscription ? "Expense" : "Expense Entry"}
              </Typography>
              {show == "1" ? (
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                >
                  Additional Expense Detail
                </Typography>
              ) : (
                false
              )}
              {show == "2" ? (
                <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                >
                  Measures
                </Typography>
              ) : (
                false
              )}

              {/* <Typography
              variant="h5"
              color="#0000D1"
              sx={{ cursor: "default" }}
              onClick={() => {
                navigate(
                  `/Apps/Secondarylistview/TR086/Finance Entry/${parentID}/${filtertype}`
                );
              }}
            >
              Finance Entry
            </Typography> */}

              {/* <Typography
                  variant="h5"
                  color="#0000D1"
                  sx={{ cursor: "default" }}
                  
                >
                  {mode === "A" ? "New"}
                </Typography> */}
            </Breadcrumbs>
          </Box>
          <Box display="flex">
            {mode !== "A" ? (
              <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                <InputLabel id="demo-select-small">Explore</InputLabel>
                <Select
                  labelId="demo-select-small"
                  id="demo-select-small"
                  value={show}
                  label="Explore"
                  onChange={screenChange}
                >
                  <MenuItem value={0}>Expense Entry</MenuItem>
                  {data?.ChildYorN === "Y" && (<MenuItem value={1}>Additional Expense Detail</MenuItem>)}
                  <MenuItem value={2}>Measures</MenuItem>

                </Select>
              </FormControl>
            ) : (
              false
            )}

            <Tooltip title="Close">
              <IconButton color="error" onClick={() => fnLogOut("Close")}>
                <ResetTvIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Logout">
              <IconButton>

                <LogoutOutlinedIcon
                  color="error"
                  onClick={() => fnLogOut("Logout")}
                />
              </IconButton>
            </Tooltip>
          </Box>
        </Box>
      </Paper>
      {show == "0" && !getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          {/* <Box m="20px"> */}
          {mode === "IM" && (
            <Box
              display="flex"
              padding={1}
              justifyContent="flex-end"
              mt="2px"
              gridColumn="span 4"
              gap={2}
              //marginBottom={-5}
              mb={{ xs: -3, sm: -5, md: -5 }}

            >
              <IconButton
                onClick={() => setShowImage(prev => !prev)}
              >
                <ArrowDownwardIcon sx={{ color: "blue" }} />
              </IconButton>
            </Box>)}
          <Formik
            initialValues={initialValue}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                fnSave(values);
              }, 100);
            }}
            validationSchema={validationSchema}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
              resetForm,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  <FormControl
                    fullWidth
                    sx={{ gridColumn: "span 2", gap: "15px" }}
                  >
                    <TextField
                      name="date"
                      type="date"
                      id="date"
                      label={
                        <>
                          Date
                          <span style={{ color: "red", fontSize: "20px" }}> * </span>
                        </>
                      }
                      variant="standard"
                      focused
                      value={values.date}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      inputFormat="YYYY-MM-DD"
                      error={!!touched.date && !!errors.date}
                      helperText={touched.date && errors.date}
                      // autoFocus
                      // required
                      InputLabelProps={{ shrink: true }}
                      disabled={mode === "M" || (mode == "E" && (values.Status != "AL" && values.Status != "QR"))}
                    />

                    <TextField
                      name="applieddate"
                      type="date"
                      id="applieddate"
                      label="Applied Date"
                      variant="standard"
                      focused
                      inputFormat="YYYY-MM-DD"
                      value={values.applieddate}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      error={!!touched.applieddate && !!errors.applieddate}
                      helperText={touched.applieddate && errors.applieddate}
                      sx={{ gridColumn: "span 2" }}
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                        readOnly: true,
                      }}
                      // required
                      InputLabelProps={{ shrink: true }}
                      disabled={mode === "M" || (mode == "E" && (values.Status != "AL" && values.Status != "QR"))}
                    />
                    {!showImage ? <React.Fragment>
                      <TextField
                        name="referenceifany"
                        type="text"
                        id="referenceifany"
                        label="Reference If Any"
                        // label={
                        //   <>
                        //     Reference If Any
                        //     <span style={{ color: "red", fontSize: "20px" }}> * </span>
                        //   </>
                        // }
                        variant="standard"
                        focused
                        // required
                        value={values.referenceifany}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={
                          !!touched.referenceifany && !!errors.referenceifany
                        }
                        helperText={
                          touched.referenceifany && errors.referenceifany
                        }
                        disabled={mode === "M" || (mode == "E" && (values.Status != "AL" && values.Status != "QR"))}
                      />

                      <FormControl sx={{ gridColumn: "span 2", display: "flex" }}>

                        <CheckinAutocomplete
                          disabled={
                            mode === "M" || (
                              mode == "E" &&
                              values.Status != "AL" &&
                              values.Status != "QR"
                            )
                          }
                          name="ProName"
                          label={
                            <span>
                              Project <span style={{ color: "red", fontSize: "20px" }}>*</span>
                            </span>
                          }
                          id="ProName"
                          value={values.ProName}
                          onChange={(newValue) => {
                            setFieldValue("ProName", newValue);
                          }}
                          error={!!touched.ProName && !!errors.ProName}
                          helperText={touched.ProName && errors.ProName}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2054","ScreenName":"Project","Filter":"parentID=${CompanyID}","Any":""}}`}
                        />
                        {/* <MultiFormikOptimizedAutocomplete
                          sx={{ width: "100%" }}
                          name="ProName"
                          label="Project"
                          id="ProName"
                          value={selectedPro}
                          onChange={(e, newValue) => {
                            setFieldValue("ProName", newValue); // Update Formik value
                            setSelectedPro(newValue); // Update local state
                            if (newValue) {
                              sessionStorage.setItem(
                                "proData",
                                JSON.stringify(newValue)
                              ); // Save to session
                            } else {
                              sessionStorage.removeItem("proData"); // Remove from session if cleared
                            }
                          }}
                          url={`${listViewurl}?data={"Query":{"AccessID":"2054","ScreenName":"Project","Filter":"parentID=${CompanyID}","Any":""}}`}
                        /> */}
                      </FormControl>

                      <FormControl
                        sx={{
                          gridColumn: "span 2",
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "flex-start",
                          gap: 2,
                        }}
                      >
                        <Box sx={{ flex: 1 }}>
                          <CheckinAutocomplete
                            variant="outlined"
                            name="overhead"
                            label={
                              <>
                                OverHead
                                <span style={{ color: "red", fontSize: "20px" }}> * </span>
                              </>
                            }
                            id="overhead"
                            value={values.overhead}
                            onChange={(newValue) => {
                              setFieldValue("overhead", newValue);
                              const childFlag = newValue?.ChildYorN;
                              setchild(childFlag);

                              console.log(childFlag, "ChildYorN");
                            }}
                            error={!!touched.overhead && !!errors.overhead}
                            helperText={touched.overhead && errors.overhead}
                            disabled={
                              mode === "M" || (
                                mode === "E" &&
                                values.Status !== "AL" &&
                                values.Status !== "QR"
                              )
                            }
                            url={`${listViewurl}?data={"Query":{"AccessID":"2032","ScreenName":"OverHead","Filter":"companyID='${CompanyID}'","Any":""}}`}
                          />
                        </Box>
                        {/* {data.OverheadType == "Cost of Employee" || values?.overhead?.OverHeadType == "Cost of Employee" */}
                        {values?.overhead?.OverHeadType == "Cost of Employee" || data.OverheadType == "Cost of Employee"

                          ? (
                            <Box sx={{ flex: 1 }}>
                              <CheckinAutocomplete
                                name="Employee"
                                label="Personnel"
                                id="Employee"
                                value={values.Employee}
                                onChange={(newValue) =>
                                  setFieldValue("Employee", newValue)
                                }
                                disabled={
                                  mode === "M" || (
                                    mode === "E" &&
                                    values.Status !== "AL" &&
                                    values.Status !== "QR"
                                  )
                                }
                                // url={`${listViewurl}?data={"Query":{"AccessID":"2118","ScreenName":"Employee","Filter":"ProjectID='${values?.ProName?.RecordID}' AND EmpID NOT IN (${EMPID})","Any":""}}`}
                                url={`${listViewurl}?data={"Query":{"AccessID":"2118","ScreenName":"Employee","Filter":"ProjectID='${values?.ProName?.RecordID}'","Any":""}}`}
                              />

                            </Box>) : null}
                        {/* {data.OverheadType == "Cost of Product" || values?.overhead?.OverHeadType == "Cost of Product" */}
                        {values?.overhead?.OverHeadType == "Cost of Product" || data.OverheadType == "Cost of Product"
                          ? (
                            <Box sx={{ flex: 1 }}>

                              <CheckinAutocomplete
                                name="Product"
                                label="Product"
                                id="Product"
                                value={values.Product}
                                onChange={(newValue) =>
                                  setFieldValue("Product", newValue)
                                }
                                disabled={
                                  mode === "M" || (
                                    mode === "E" &&
                                    values.Status !== "AL" &&
                                    values.Status !== "QR"
                                  )
                                }
                                url={`${listViewurl}?data={"Query":{"AccessID":"2137","ScreenName":"Product","Filter":"CompanyID='${CompanyID}' AND ItemsDesc ='Product'","Any":""}}`}
                              />
                            </Box>) : null}
                        {/* {data.OverheadType == "Cost of Material" || values?.overhead?.OverHeadType == "Cost of Material" */}
                        {values?.overhead?.OverHeadType == "Cost of Material" || data.OverheadType == "Cost of Material"

                          ? (
                            <Box sx={{ flex: 1 }}>
                              <CheckinAutocomplete
                                name="Material"
                                label="Material"
                                id="Material"
                                value={values.Material}
                                onChange={(newValue) =>
                                  setFieldValue("Material", newValue)
                                }
                                disabled={
                                  mode === "M" || (
                                    mode === "E" &&
                                    values.Status !== "AL" &&
                                    values.Status !== "QR"
                                  )
                                }
                                url={`${listViewurl}?data={"Query":{"AccessID":"2138","ScreenName":"Material","Filter":"CompanyID='${CompanyID}' AND ItemsDesc ='Material'","Any":""}}`}
                              />

                            </Box>
                          ) : null}
                        {/* {data.OverheadType == "Cost of Service" || values?.overhead?.OverHeadType == "Cost of Service" */}
                        {values?.overhead?.OverHeadType == "Cost of Service" || data.OverheadType == "Cost of Service"
                          ? (
                            <Box sx={{ flex: 1 }}>
                              <CheckinAutocomplete
                                name="Service"
                                label="Service"
                                id="Service"
                                value={values.Service}
                                onChange={(newValue) =>
                                  setFieldValue("Service", newValue)
                                }
                                disabled={
                                  mode === "M" || (
                                    mode === "E" &&
                                    values.Status !== "AL" &&
                                    values.Status !== "QR"
                                  )
                                }
                                url={`${listViewurl}?data={"Query":{"AccessID":"2139","ScreenName":"Service","Filter":"CompanyID='${CompanyID}' AND ItemsDesc ='Services'","Any":""}}`}
                              />

                            </Box>
                          ) : null}
                      </FormControl>

                      {/* {touched.overhead && errors.overhead && (
                          <div style={{ color: "red", fontSize: "12px", marginTop: "1px" }}>
                            {errors.overhead}
                          </div>
                        )} */}

                      {/* <TextField
                        name="amount"
                        type="text"
                        id="amount"
                        label={
                          <>
                            Amount
                            <span style={{ color: "red", fontSize: "20px" }}> * </span>
                          </>
                        }
                        variant="standard"
                        focused
                        value={values.amount}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        error={!!touched.amount && !!errors.amount}
                        helperText={touched.amount && errors.amount}
                        InputProps={{
                          inputProps: {
                            style: { textAlign: "right" },
                            min: 0,
                            max: 24,
                          },
                        }}
                        // required
                        disabled={mode == "E" && (values.Status != "AL" && values.Status != "QR")}
                      /> */}
                      <TextField
                        name="amount"
                        disabled={mode === "M" || (mode == "E" && (values.Status != "AL" && values.Status != "QR"))}
                        id="amount"
                        label="Amount"
                        // label={
                        //   <>
                        //     Amount
                        //     <span style={{ color: "red", fontSize: "20px" }}> * </span>
                        //   </>
                        // }
                        variant="standard"
                        focused
                        value={values.amount}
                        error={!!touched.amount && !!errors.amount}
                        helperText={touched.amount && errors.amount}
                        onChange={(e) => {
                          const val = e.target.value;

                          // Allow numbers with optional decimal (up to 2 digits)
                          if (/^\d*\.?\d{0,2}$/.test(val)) {
                            setFieldValue("amount", val);
                          }
                        }}
                        onBlur={(e) => {
                          handleBlur(e);
                          let val = e.target.value;

                          if (val === "" || val === ".") {
                            setFieldValue("amount", "0.00");
                            return;
                          }

                          // Ensure decimal exists
                          if (!val.includes(".")) {
                            val = `${val}.00`;
                          }

                          const num = Number(val);

                          // ✅ Force exactly 2 decimals
                          setFieldValue("amount", num.toFixed(2));
                        }}
                        InputProps={{
                          readOnly: true,
                          inputProps: {
                            style: { textAlign: "right" },
                            min: 0,
                            max: 24,
                          },
                        }}
                      />
                      <TextField
                        disabled={mode === "M" || (mode == "E" && (values.Status != "AL" && values.Status != "QR"))}
                        fullWidth
                        variant="outlined"
                        type="text"
                        label={
                          <>
                            Comments
                            <span style={{ color: "red", fontSize: "20px" }}> * </span>
                          </>
                        }
                        // required
                        multiline
                        rows={6}
                        value={values.comments}
                        id="comments"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        name="comments"
                        error={!!touched.comments && !!errors.comments}
                        helperText={touched.comments && errors.comments}
                        sx={{
                          gridColumn: "span 2",
                          backgroundColor: "",
                          "& .MuiFilledInput-root": {
                            backgroundColor: "",
                          },
                        }}
                        focused
                      />

                      {mode == "M" ||
                        (mode == "E" &&
                          (values.Status == "RJ" || values.Status == "QR")) ? (
                        <TextField
                          disabled={mode == "E" && values.Status != "AL"}
                          fullWidth
                          variant="outlined"
                          type="text"
                          label={
                            <>
                              Manager Comments
                              <span
                                style={{ color: "red", fontSize: "20px" }}
                              >
                                {" "}
                                *{" "}
                              </span>
                            </>
                          }
                          // label="Manager Comments"
                          // required
                          multiline
                          rows={6}
                          value={values.managerComments}
                          id="managerComments"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.managerComments && !!errors.managerComments}
                          helperText={touched.managerComments && errors.managerComments}
                          name="managerComments"
                          sx={{
                            gridColumn: "span 2",
                          }}
                          focused
                        />
                      ) : (
                        false
                      )}
                      {mode == "M" && (
                        <TextField
                          select
                          label={
                            <>
                              Status<span style={{ color: "red", fontSize: "20px" }}> * </span>
                            </>
                          }
                          id="Status"
                          name="Status"
                          value={values.Status}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.Status && !!errors.Status}
                          helperText={touched.Status && errors.Status}
                          focused
                          variant="standard"
                        >
                          {mode != "M" && <MenuItem value="AL">Applied</MenuItem>}
                          <MenuItem disabled={mode != "M"} value="AP">
                            Approved
                          </MenuItem>
                          <MenuItem disabled={mode != "M"} value="RJ">
                            Rejected
                          </MenuItem>
                          {mode == "M" && (
                            <MenuItem value="QR">Query</MenuItem>
                          )}
                        </TextField>
                      )}

                      {mode == "E" && values.Status == "AP" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="success">
                          Your Expense Request has been Approved.
                        </Alert>
                      )}
                      {mode == "E" && values.Status == "RJ" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="error">
                          Your Expense Request has been Rejected.
                        </Alert>
                      )}
                      {mode == "E" && values.Status == "QR" && (
                        <Alert variant="filled" sx={{ mt: 1 }} severity="warning">
                          Your Expense Request has been Queried.
                        </Alert>
                      )}
                    </React.Fragment> : false}
                  </FormControl>
                </Box>
                <Box
                  display="flex"
                  padding={1}
                  justifyContent="end"
                  mt="20px"
                  gap="20px"
                >
                  {/* <IconButton
                    size="small"
                    color="warning"
                    aria-label="upload picture"
                    component="label"
                  >
                    <input
                      hidden
                      accept="all/*"
                      type="file"
                      onChange={getFileChange}
                    />
                    <PictureAsPdfOutlinedIcon />
                  </IconButton>
                  <Button
                    variant="contained"
                    component={"a"}
                    onClick={() => {
                      data.Attachment || ImageName
                        ? window.open(
                            ImageName
                              ? store.getState().globalurl.attachmentUrl +
                                  ImageName
                              : store.getState().globalurl.attachmentUrl +
                                  data.Attachment,
                            "_blank"
                          )
                        : toast.error("Please Upload File");
                    }}
                  >
                    View
                  </Button> */}
                  {/* {mode === "E" ? (
                    <Box display="flex" alignItems="center" gap={1}>
                      <FileUploadIconButton onFileSelect={fileUpload} />
                    </Box>
                  ) : null} */}
                  {mode == "IM" && (
                    <>
                      <Box>
                        <TextField
                          name="purpose"
                          type="text"
                          id="purpose"
                          label="Purpose"
                          variant="standard"
                          focused
                          value={values.purpose}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          error={!!touched.purpose && !!errors.purpose}
                          helperText={touched.purpose && errors.purpose}
                          sx={{ gridColumn: "span 2", height: "20px", marginBottom: "20px" }}
                          InputLabelProps={{ shrink: true }}

                        />
                      </Box>
                      <FileUploadIconButton onFileSelect={(file) => {
                        fileUpload(
                          file,
                          EMPID,
                          "upload",
                          "",
                          values.purpose
                        )
                        setFieldValue("purpose", "");
                      }}
                      />
                    </>

                  )}
                  {mode != "M" &&
                    (values.Status == "AL" ||
                      values.Status == "QR" ||
                      mode == "A") && (
                      <LoadingButton
                        disabled={mode == "IM"}
                        color="secondary"
                        variant="contained"
                        type="submit"
                        loading={loading}
                      >
                        Save
                      </LoadingButton>
                    )}
                  {mode == "M" && (
                    <LoadingButton
                      disabled={mode == "IM"}
                      color="secondary"
                      variant="contained"
                      type="submit"
                      loading={loading}
                    >
                      Save
                    </LoadingButton>
                  )}
                  {mode != "M" && values.Status == "AL" && (
                    <Button
                      color="error"
                      variant="contained"
                      disabled={mode == "IM"}
                      onClick={() => {
                        Swal.fire({
                          title: errorMsgData.Warningmsg.Delete,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Confirm",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            fnSave(values, resetForm, "harddelete");
                            // navigate(-1);
                          } else {
                            return;
                          }
                        });
                      }}
                    >
                      Delete
                    </Button>
                  )}
                  {mode == "M" && (
                    <Button
                      color="error"
                      variant="contained"
                      disabled={mode == "IM"}
                      onClick={() => {
                        Swal.fire({
                          title: `Do you want Delete?`,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Confirm",
                        }).then((result) => {
                          if (result.isConfirmed) {
                            fnSave(values, resetForm, "harddelete");
                            // navigate(-1);
                          } else {
                            return;
                          }
                        });
                      }}
                    >
                      Delete
                    </Button>
                  )}
                  <Button
                    type="reset"
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      if (mode === "M") {
                        navigate(-1);
                      }
                      else (
                        navigate("/Apps/Secondarylistview/TR086/Finance%20Entry/E")
                      );
                    }}
                  >
                    Cancel
                  </Button>
                  {/* <LoadingButton
                    loading={loading}
                    variant="contained"
                    color="secondary"
                    type="submit"
                  >
                    SAVE
                  </LoadingButton>
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => {
                      Swal.fire({
                        title: `Do you want Delete?`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Confirm",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          fnSave(values, resetForm, "harddelete");
                          navigate("/Apps/TR086/Finance%20Entry");
                        } else {
                          return;
                        }
                      });
                    }}
                  >
                    Delete
                  </Button>
                  <Button
                    variant="contained"
                    color="warning"
                    onClick={() => {
                      navigate(
                        `/Apps/Secondarylistview/TR086/Finance Entry/${parentID}`
                      );
                    }}
                  >
                    CANCEL
                  </Button> */}
                </Box>
              </form>
            )}
          </Formik>
          <Popup
            title="OverHead"
            openPopup={openOHPopup}
            setOpenPopup={setOpenOHPopup}
          >
            <Listviewpopup
              accessID="2032"
              screenName="OverHead"
              childToParent={childToParent}
              filterName={"FinanceCategoryType"}
              filterValue={parentID}
            />
          </Popup>
          <FileListPopup
            open={open}
            onClose={() => setOpen(false)}

            appId={recID}
            empId={EMPID}
          />
          <Popup
            title={
              parentID == "E"
                ? "Employee"
                : parentID == "P"
                  ? "Products"
                  : parentID == "F"
                    ? "Fixed Assets"
                    : "Material"
            }
            openPopup={openEMPLOYEEPopup}
            setOpenPopup={setOpenEMPLOYEEPopup}
          >
            <Listviewpopup
              accessID={
                parentID == "E"
                  ? "2024"
                  : parentID == "P"
                    ? "2002"
                    : parentID == "F"
                      ? "2055"
                      : "2000"
              }
              screenName={
                parentID == "E"
                  ? "Employee"
                  : parentID == "P"
                    ? "Products"
                    : parentID == "F"
                      ? "Fixed Assets"
                      : "Material"
              }
              childToParent={childToParent}
            />
          </Popup>
          {/* </Box> */}
        </Paper>
      ) : (
        false
      )}

      {show == "0" && mode === "IM" && files.length > 0 ? (
        <Box mt={2}
        >
          <Paper elevation={3} sx={{ padding: 2 }}>
            {/* <Typography variant="h6" gutterBottom>
              Uploaded Files
            </Typography> */}
            <TableContainer component={Paper} >
              <Table size="small">
                <TableHead>
                  <TableRow sx={rowSx}>
                    <TableCell width={20}><strong>S.No</strong></TableCell>
                    <TableCell><strong>Uploaded Date</strong></TableCell>
                    <TableCell ><strong>Filename</strong></TableCell>
                    <TableCell ><strong>Purpose</strong></TableCell>
                    <TableCell ><strong>Source</strong></TableCell>
                    <TableCell><strong>View</strong></TableCell>


                  </TableRow>
                </TableHead>
                <TableBody>
                  {files.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        No files uploaded yet.
                      </TableCell>
                    </TableRow>
                  ) : (
                    files.map((file, index) => (
                      <TableRow key={file.id || index} sx={rowSx}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{file.uploadedDate}</TableCell>
                        <TableCell>{file.filename}</TableCell>
                        <TableCell>{file.purpose}</TableCell>
                        <TableCell>{file.source}</TableCell>
                        <TableCell>
                          <Tooltip title="Open File">
                            <IconButton
                              color="primary"
                              component="a"
                              href={file.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              size="small"
                            >
                              <OpenInNewIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="delete">
                            <IconButton
                              color="error"
                              onClick={() => fileUpload(
                                file.filename,
                                EMPID,
                                "delete",
                                file.id,
                                file.purpose
                              )}
                              size="small"
                            >
                              <DeleteForeverIcon fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </TableCell>

                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      ) : null}
      {show == "1" ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={DetailinitialValues}
            enableReinitialize={true}
            // validationSchema={validationSchema1}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                AddexpFnsave(values, resetForm, false);
              }, 100);
            }}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              resetForm,
              setFieldValue
            }) => (
              <form
                onSubmit={handleSubmit}
                onReset={() => {
                  selectCellRowData({ rowData: {}, mode: "A", field: "" });
                  resetForm();
                }}

              >
                <Box
                  display="grid"
                  gap={formGap}
                  padding={1}
                  gridTemplateColumns="repeat(2 , minMax(0,1fr))"
                  // gap="30px"
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 2",
                    },
                  }}
                >
                  <FormControl sx={{ gap: formGap }}>
                    {/* <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="code"
                      name="code"
                      value={values.code}
                      label="Date"
                      focused
                      inputProps={{ readOnly: true }}
                    /> */}
                    <TextField
                      name="code"
                      type="date"
                      id="code"
                      label="Date"
                      variant="standard"
                      focused
                      value={values.code}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      inputFormat="YYYY-MM-DD"
                      // autoFocus
                      // required
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ readOnly: true }}
                    />
                    <TextField
                      fullWidth
                      variant="standard"
                      type="text"
                      id="description"
                      name="description"
                      value={values.description}
                      label="Name"
                      focused
                      inputProps={{ readOnly: true }}
                    />
                  </FormControl>
                  <Stack
                    sx={{
                      //    width: {sm:'100%',md:'100%',lg:'100%'},
                      //gridColumn: "span 2",
                      alignContent: "center",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                      right: "0px",
                    }}
                  >
                    <Avatar
                      variant="rounded"
                      src={userimg}
                      sx={{ width: "200px", height: "120px" }}
                    />
                  </Stack>

                  <Box
                    m="5px 0 0 0"
                    //height={dataGridHeight}
                    gridColumn="span 2"
                    height="50vh"
                    sx={{
                      // width: "100%",
                      "& .MuiDataGrid-root": {
                        border: "none",
                      },
                      "& .MuiDataGrid-cell": {
                        borderBottom: "none",
                      },
                      "& .name-column--cell": {
                        color: colors.greenAccent[300],
                      },
                      "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[800],
                        borderBottom: "none",
                      },
                      "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                      },
                      "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[800],
                      },
                      "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                      },
                      "& .odd-row": {
                        backgroundColor: "",
                        color: "", // Color for odd rows
                      },
                      "& .even-row": {
                        backgroundColor: "#D3D3D3",
                        color: "", // Color for even rows
                      },
                    }}
                  >
                    <DataGrid
                      sx={{
                        // width: "100%", // important
                        "& .MuiDataGrid-footerContainer": {
                          height: dataGridHeaderFooterHeight,
                          minHeight: dataGridHeaderFooterHeight,
                        },
                      }}
                      rows={explorelistViewData}
                      // columns={columns}
                      columns={columns}
                      disableSelectionOnClick
                      getRowId={(row) => row.RecordID}
                      rowHeight={dataGridRowHeight}
                      headerHeight={dataGridHeaderFooterHeight}
                      pageSize={pageSize}
                      onPageSizeChange={(newPageSize) =>
                        setPageSize(newPageSize)
                      }
                      onCellClick={(params) => {
                        selectCellRowData({
                          rowData: params.row,
                          mode: "E",
                          field: params.field,
                          setFieldValue
                        });
                        setScreen(2)
                        setOHId(params.row.OverheadRecordID)
                        setFEtype(params.row.RecordID)
                        dispatch(
                          measureget({
                            FinanceentryID: params.row.RecordID
                            // ,OverheadsRecordID: params.row.OverheadRecordID 
                          })
                        );
                      }}
                      rowsPerPageOptions={[5, 10, 20]}
                      pagination
                      components={{
                        Toolbar: Employee,
                      }}
                      onStateChange={(stateParams) =>
                        setRowCount(stateParams.pagination.rowCount)
                      }
                      getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0
                          ? "odd-row"
                          : "even-row"
                      }
                      loading={exploreLoading}
                      componentsProps={{
                        toolbar: {
                          showQuickFilter: true,
                          quickFilterProps: { debounceMs: 500 },
                        },
                      }}
                    />
                  </Box>

                  {/* <FormControl sx={{ gap: formGap }}>
                    <CheckinAutocomplete
                      variant="outlined"
                      name="overheaddetail"
                      label="Overhead"
                      // label={
                      //   <>
                      //     OverHead
                      //     <span style={{ color: "red", fontSize: "20px" }}> * </span>
                      //   </>
                      // }
                      id="overheaddetail"
                      value={values.overheaddetail}
                      onChange={(newValue) => {
                        setFieldValue("overheaddetail", newValue);
                      }}
                      readOnly
                      error={!!touched.overheaddetail && !!errors.overheaddetail}
                      helperText={touched.overheaddetail && errors.overheaddetail}
                      url={`${listViewurl}?data={"Query":{"AccessID":"2032","ScreenName":"OverHead","Filter":"companyID='${CompanyID}'","Any":""}}`}
                    />
                  
                    <TextField
                      name="detailamount"
                      id="detailamount"
                      label={
                        <>
                          Amount
                          <span style={{ color: "red", fontSize: "20px" }}> * </span>
                        </>
                      }
                      variant="standard"
                      focused
                      value={values.detailamount}
                      error={!!touched.detailamount && !!errors.detailamount}
                      helperText={touched.detailamount && errors.detailamount}
                      InputProps={{
                        inputProps: {
                          style: { textAlign: "right" },
                          min: 0,
                          max: 24,
                        },
                      }}
                      onChange={(e) => {
                        const val = e.target.value;

                        // ✅ Allow numbers with optional decimal (up to 2 digits)
                        if (/^\d*\.?\d{0,2}$/.test(val)) {
                          setFieldValue("detailamount", val);
                        }
                      }}
                      onBlur={(e) => {
                        handleBlur(e);
                        let val = e.target.value;

                        if (val === "" || val === ".") {
                          setFieldValue("detailamount", "0.00");
                          return;
                        }

                        // ✅ Ensure decimal exists
                        if (!val.includes(".")) {
                          val = `${val}.00`;
                        }

                        const num = Number(val);

                        // ✅ Force exactly 2 decimals
                        setFieldValue("detailamount", num.toFixed(2));
                      }}
                    />
                 
                  </FormControl> */}
                </Box>
                <Box
                  display="flex"
                  justifyContent="end"
                  padding={1}
                  // style={{ marginTop: "-40px" }}
                  gap={2}
                >
                  {/* <LoadingButton
                    color="secondary"
                    variant="contained"
                    type="submit"
                  // loading={isLoading}
                  >
                    Save
                  </LoadingButton> */}

                  <Button
                    type="reset"
                    color="warning"
                    variant="contained"
                    onClick={() => {
                      setScreen(0);
                      dispatch(getFetchData({ accessID, get: "get", recID }));
                    }}
                  >
                    Cancel
                  </Button>
                </Box>

              </form>
            )}
          </Formik>
        </Paper >
      ) : (
        false
      )}
      {show == "2" && !getLoading ? (
        <Paper elevation={3} sx={{ margin: "10px" }}>
          <Formik
            initialValues={initialValue2}
            onSubmit={(values, { resetForm }) => {
              setTimeout(() => {
                MeasureFnsave(values, resetForm);
              }, 100);
            }}
            validationSchema={validationSchema1}
            enableReinitialize={true}
          >
            {({
              errors,
              touched,
              handleBlur,
              handleChange,
              isSubmitting,
              values,
              handleSubmit,
              setFieldValue,
              resetForm,
            }) => (
              <form onSubmit={handleSubmit}>
                <Box
                  display="grid"
                  gridTemplateColumns="repeat(4 , minMax(0,1fr))"
                  gap={formGap}
                  padding={1}
                  sx={{
                    "& > div": {
                      gridColumn: isNonMobile ? undefined : "span 4",
                    },
                  }}
                >
                  {/* <FormControl
                    // fullWidth
                    sx={{ gridColumn: "span 2", gap: "15px" }}
                  > */}
                  <TextField
                    name="code"
                    type="date"
                    id="code"
                    label="Date"
                    variant="standard"
                    focused
                    value={values.code}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    inputFormat="YYYY-MM-DD"
                    // autoFocus
                    // required
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ readOnly: true }}
                    sx={{ gridColumn: "span 2" }}

                  />
                  <TextField
                    fullWidth
                    variant="standard"
                    type="text"
                    id="description"
                    name="description"
                    value={values.description}
                    label="Name"
                    focused
                    inputProps={{ readOnly: true }}
                    sx={{ gridColumn: "span 2" }}

                  />
                  <TextField
                    fullWidth
                    variant="standard"
                    type="text"
                    id="uom"
                    name="uom"
                    value={values.uom}
                    // label="UOM"
                    label={
                      <>
                        UOM
                        <span style={{ color: "red", fontSize: "20px" }}> * </span>
                      </>
                    }
                    focused
                    onBlur={handleBlur}
                    onChange={handleChange}
                    error={!!touched.uom && !!errors.uom}
                    helperText={touched.uom && errors.uom}
                    sx={{ gridColumn: "span 2" }}

                  />
                  <TextField
                    fullWidth
                    variant="standard"
                    type="number"
                    id="Qty"
                    name="Qty"
                    value={values.Qty}
                    label="Quantity"

                    onBlur={handleBlur}
                    onChange={(e) => {
                      const qty = e.target.value;
                      setFieldValue("Qty", qty);

                      const rate = values.rate || 0;
                      setFieldValue("measureamount", (qty * rate).toFixed(2));
                    }}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#ffffff",
                      },
                      gridColumn: "span 2"
                    }}
                    focused
                    InputProps={{
                      inputProps: {
                        style: { textAlign: 'right', maxLength: 90 },
                      },
                    }}

                  />

                  <TextField
                    fullWidth
                    variant="standard"
                    type="number"
                    id="rate"
                    value={values.rate}
                    name="rate"
                    label="Rate"
                    onChange={(e) => {
                      const rate = e.target.value || 0;
                      setFieldValue("rate", rate);

                      const qty = values.Qty || 0;
                      setFieldValue("measureamount", (qty * rate).toFixed(2));
                    }}
                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#ffffff",
                      },
                      gridColumn: "span 2"
                    }}
                    focused
                    //  InputProps={{ readOnly: true }}
                    InputProps={{
                      // readOnly: true,
                      inputProps: {
                        style: { textAlign: 'right', maxLength: 90 },
                      },
                    }}

                  //  InputProps={{
                  />


                  <TextField
                    fullWidth
                    variant="standard"
                    type="number"
                    id="measureamount"
                    name="measureamount"
                    value={values.measureamount}
                    label="Value"

                    sx={{
                      backgroundColor: "#ffffff",
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#ffffff",
                      },
                      gridColumn: "span 2"
                    }}
                    focused
                    InputProps={{
                      inputProps: {
                        style: { textAlign: 'right', },
                      },
                    }}

                  />

                  <TextField
                    fullWidth
                    variant="standard"
                    type="text"
                    id="measurecomments"
                    name="measurecomments"
                    label="Comments"
                    value={values.measurecomments ?? ""}
                    onChange={(e) =>
                      setFieldValue("measurecomments", e.target.value)
                    }
                    sx={{
                      backgroundColor: "#ffffff", // Set the background to white
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#ffffff", // Ensure the filled variant also has a white background
                      },
                      gridColumn: "span 2"
                    }}
                    focused
                    autoFocus
                    multiline
                    inputProps={{ maxLength: 90 }}

                  />
                  {/* </FormControl> */}
                </Box>
                <Box
                  display="flex"
                  padding={1}
                  justifyContent="end"
                  mt="20px"
                  gap="20px"
                >

                  <LoadingButton
                    disabled={mode == "IM"}
                    color="secondary"
                    variant="contained"
                    type="submit"
                    loading={loading}
                  >
                    Save
                  </LoadingButton>

                  <Button
                    type="reset"
                    color="warning"
                    variant="contained"
                    onClick={() =>
                      setScreen(0)}
                  >
                    Cancel
                  </Button>
                  {/* <LoadingButton
                    loading={loading}
                    variant="contained"
                    color="secondary"
                    type="submit"
                  >
                    SAVE
                  </LoadingButton>
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => {
                      Swal.fire({
                        title: `Do you want Delete?`,
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Confirm",
                      }).then((result) => {
                        if (result.isConfirmed) {
                          fnSave(values, resetForm, "harddelete");
                          navigate("/Apps/TR086/Finance%20Entry");
                        } else {
                          return;
                        }
                      });
                    }}
                  >
                    Delete
                  </Button>
                  <Button
                    variant="contained"
                    color="warning"
                    onClick={() => {
                      navigate(
                        `/Apps/Secondarylistview/TR086/Finance Entry/${parentID}`
                      );
                    }}
                  >
                    CANCEL
                  </Button> */}
                </Box>
              </form>
            )}
          </Formik>
          <Popup
            title="OverHead"
            openPopup={openOHPopup}
            setOpenPopup={setOpenOHPopup}
          >
            <Listviewpopup
              accessID="2032"
              screenName="OverHead"
              childToParent={childToParent}
              filterName={"FinanceCategoryType"}
              filterValue={parentID}
            />
          </Popup>
          <FileListPopup
            open={open}
            onClose={() => setOpen(false)}

            appId={recID}
            empId={EMPID}
          />
          <Popup
            title={
              parentID == "E"
                ? "Employee"
                : parentID == "P"
                  ? "Products"
                  : parentID == "F"
                    ? "Fixed Assets"
                    : "Material"
            }
            openPopup={openEMPLOYEEPopup}
            setOpenPopup={setOpenEMPLOYEEPopup}
          >
            <Listviewpopup
              accessID={
                parentID == "E"
                  ? "2024"
                  : parentID == "P"
                    ? "2002"
                    : parentID == "F"
                      ? "2055"
                      : "2000"
              }
              screenName={
                parentID == "E"
                  ? "Employee"
                  : parentID == "P"
                    ? "Products"
                    : parentID == "F"
                      ? "Fixed Assets"
                      : "Material"
              }
              childToParent={childToParent}
            />
          </Popup>
          {/* </Box> */}
        </Paper>
      ) : (
        false
      )}
    </React.Fragment>
  );
};

export default Editfinance;
